define(function () {

	var locale = 'fr-FR';

	var resource = {};
	resource[locale] = {};
	resource[locale]['press'] = require("./press.json");
	resource[locale]['pro'] = require("./pro.json");
	resource[locale]['index'] = require("./index.json");
	resource[locale]['partners'] = require("./partners.json");
	resource[locale]['realestate'] = require("./realestate.json");
	resource[locale]['trustguarantee'] = require("./trustguarantee.json");
	resource[locale]['chooseno1'] = require("./chooseno1.json");
	resource[locale]['search'] = require("./search.json");
	resource[locale]['search-result'] = require("./search-result.json");
	resource[locale]['news_body'] = require("./news_body.json");
	resource[locale]['news_article_body'] = require("./news_article_body.json");
	resource[locale]['enroll'] = require("./enroll.json");
	resource[locale]['single-survey'] = require("./single-survey.json");
	resource[locale]['newsletter-bottom-widget'] = require("./newsletter-bottom-widget.json");
	resource[locale]['survey_request'] = require("./survey_request.json");
	resource[locale]['search_review_redirect_immoreviews'] = require("./search_review_redirect_immoreviews.json");
	resource[locale]['recommend-company'] = require("./recommend-company.json");
	resource[locale]['login'] = require("./login.json");
	resource[locale]['functionality'] = require("./functionality.json");
	resource[locale]['bottom-contact'] = require("./bottom-contact.json");
	resource[locale]['career'] = require("./career.json");
	resource[locale]['department'] = require("./department.json");
	resource[locale]['bottom-subscribe-newsletter'] = require("./bottom-subscribe-newsletter.json");
	resource[locale]['job'] = require("./job.json");
	resource[locale]['contact'] = require("./contact.json");
	resource[locale]['history'] = require("./history.json");
	resource[locale]['career_fair'] = require("./career_fair.json");
	resource[locale]['career_fair_job_modal'] = require("./career_fair_job_modal.json");
	resource[locale]['ifop'] = require("./ifop.json");
	resource[locale]['fair_sign_up'] = require("./fair-sign-up.json");
	resource[locale]['datetime_language'] = require("./datetime-language.json");
	resource[locale]['services'] = require("./services.json");
	resource[locale]['certificate'] = require("./certificate.json");
	resource[locale]['certificate-error'] = require("./certificate-error.json");
	resource[locale]['country'] = require("./country.json");
	resource[locale]['certificate-modal-contact'] = require("./certificate-modal-contact.json");
	resource[locale]['certificate-modal-survey-flag'] = require("./certificate-modal-survey-flag.json");
	resource[locale]['certificate-toolbar'] = require("./certificate-toolbar.json");
	resource[locale]['certificate-company'] = require("./certificate-company.json");
	resource[locale]['certificate-description'] = require("./certificate-description.json");
	resource[locale]['certificate-company-info'] = require("./certificate-company-info.json");
	resource[locale]['certificate-company-detail-rating'] = require("./certificate-company-detail-rating.json");
	resource[locale]['certificate-review-search'] = require("./certificate-review-search.json");
	resource[locale]['certificate-sort-bar'] = require("./certificate-sort-bar.json");
	resource[locale]['certificate-review'] = require("./certificate-review.json");
	resource[locale]['certificate-about-os'] = require("./certificate-about-os.json");
	resource[locale]['google-recaptcha'] = require("./google-recaptcha.json");
	resource[locale]['lifemoments'] = require("./life-moments.json");
	resource[locale]['legal'] = require("./legal.json");
	resource[locale]['unsubscribeemail'] = require("./unsubscribe-email.json");
	resource[locale]['termsservice'] = require("./terms-service.json");
	resource[locale]['dataprotection'] = require("./data-protection.json");
	resource[locale]['forgot-password'] = require("./forgot-password.json");
	resource[locale]['survey-answered'] = require("./survey-answered.json");
	resource[locale]['survey-error'] = require("./survey-error.json");
	resource[locale]['survey-flag'] = require("./survey-flag.json");
	resource[locale]['survey-modification'] = require("./survey-modification.json");
	resource[locale]['survey-opt-out'] = require("./survey-opt-out.json");
	resource[locale]['survey-unpublish'] = require("./survey-unpublish.json");
	resource[locale]['survey-unpublish-confirm'] = require("./survey-unpublish-confirm.json");
	resource[locale]['survey-unpublish-modal-callback'] = require("./survey-unpublish-modal-callback.json");
	resource[locale]['drivingschool'] = require("./drivingschool.json");
	resource[locale]['childcare'] = require("./childcare.json");
	resource[locale]['phone-widget'] = require("./phone-widget.json");
	resource[locale]['support-document-list'] = require("./support-document-list.json");
	resource[locale]['password_reset'] = require("./password_reset.json");
	resource[locale]['header'] = require("./header.json");
	resource[locale]['footer'] = require("./footer.json");
	resource[locale]['partner-modal'] = require("./partner-modal.json");
	resource[locale]['survey-introduction'] = require("./survey-introduction.json");
	resource[locale]['survey-step1'] = require("./survey-step1.json");
	resource[locale]['survey-step2'] = require("./survey-step2.json");
	resource[locale]['survey-step3'] = require("./survey-step3.json");
	resource[locale]['survey-thankyou'] = require("./survey-thankyou.json");
	resource[locale]['message'] = require("./message.json");
	resource[locale]['extranet-auth'] = require("./extranet-auth.json");
	resource[locale]['resources-gmb-agency'] = require("./resources-gmb-agency.json");
	return resource;
});